/**
 * Akomoda status tokens — aligned to brand palette.
 * Room: available(teal) · occupied(blue) · dirty(amber) · maintenance(red) · blocked(slate)
 */
const STATUS_STYLES = {
    // Room status
    clean: "bg-orange-50 text-orange-700 border-orange-200",            // available
    available: "bg-orange-50 text-orange-700 border-orange-200",
    occupied: "bg-blue-50 text-blue-700 border-blue-200",
    dirty: "bg-amber-50 text-amber-800 border-amber-200",
    maintenance: "bg-red-50 text-red-700 border-red-200",
    out_of_order: "bg-red-50 text-red-700 border-red-200",
    blocked: "bg-slate-100 text-slate-700 border-slate-300",

    // Reservation status
    pending: "bg-amber-50 text-amber-800 border-amber-200",
    confirmed: "bg-blue-50 text-blue-700 border-blue-200",
    checked_in: "bg-blue-50 text-blue-700 border-blue-200",
    checked_out: "bg-slate-100 text-slate-700 border-slate-300",
    cancelled: "bg-red-50 text-red-700 border-red-200",
    no_show: "bg-amber-50 text-amber-800 border-amber-200",

    // Arrivals/departures helpers
    arriving: "bg-orange-50 text-orange-700 border-orange-200",
    departing: "bg-slate-100 text-slate-700 border-slate-300",

    // Tasks
    in_progress: "bg-blue-50 text-blue-700 border-blue-200",
    done: "bg-green-50 text-green-700 border-green-200",
    skipped: "bg-slate-100 text-slate-700 border-slate-300",
    paid: "bg-green-50 text-green-700 border-green-200",

    // Priorities
    high: "bg-red-50 text-red-700 border-red-200",
    normal: "bg-slate-100 text-slate-700 border-slate-300",
    low: "bg-orange-50 text-orange-700 border-orange-200",

    // Subscription
    active: "bg-green-50 text-green-700 border-green-200",
    trial: "bg-blue-50 text-blue-700 border-blue-200",

    // Channels
    connected: "bg-green-50 text-green-700 border-green-200",
    error: "bg-red-50 text-red-700 border-red-200",
};

export function StatusBadge({ status, label }) {
    const cls = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-300";
    const text = label || (status || "").toString().replace(/_/g, " ");
    return (
        <span
            data-testid={`status-${status}`}
            className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium tracking-wide ${cls}`}
        >
            <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
            {text}
        </span>
    );
}
